import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



const cardData = {
  keyword: "Innova Crysta On Rent in Pune",
  heading: "Lotus Cab: Innova Crysta On Rent in Pune",

  headingDescription:
    "Lotus Cab provides premium Toyota Innova Crysta on rent in Pune for airport transfers, corporate travel, weddings, family tours, and long-distance outstation trips. Known for its powerful performance, luxurious interiors, and superior comfort, the Innova Crysta is one of the most preferred SUVs for highway travel. Our 7-seater AC vehicles are well-maintained, sanitized, and driven by professional, uniformed chauffeurs. We offer transparent per-km pricing with one-way and round-trip options available. Whether you need a comfortable airport drop or a luxury outstation ride, Lotus Cab ensures a smooth, safe, and hassle-free travel experience across Pune and beyond.",

  top: "Top Places to Visit in Pune with Innova Crysta",

  topPlaces: [
    {
      title: "Shaniwar Wada",
      description:
        "Shaniwar Wada is one of Pune’s most iconic historical landmarks built during the Peshwa era. It reflects the grandeur of Maratha architecture and attracts tourists year-round. Families and corporate visitors often include it in city tours. The spacious Innova Crysta ensures comfortable group sightseeing. Smooth city navigation makes travel convenient. Lotus Cab provides reliable local travel support."
    },
    {
      title: "Sinhagad Fort",
      description:
        "Sinhagad Fort is a popular weekend destination located near Pune. Known for its historic significance and scenic hill views, it attracts families and adventure lovers. Comfortable SUV travel is ideal for the hilly route. The Innova Crysta provides stable and smooth highway performance. Ideal for family day trips. Lotus Cab ensures safe driving on hill roads."
    },
    {
      title: "Aga Khan Palace",
      description:
        "Aga Khan Palace is an important monument connected to India’s freedom struggle. The palace features beautiful gardens and historic exhibits. Popular among educational and corporate tours. The luxury seating of Innova Crysta enhances city sightseeing comfort. Convenient pickup and drop available."
    },
    {
      title: "Dagdusheth Ganpati Temple",
      description:
        "This famous temple attracts thousands of devotees daily. Located in central Pune, it is easily accessible by road. Ideal for family darshan visits. The Innova Crysta offers smooth city travel with AC comfort."
    },
    {
      title: "Lavasa",
      description:
        "Lavasa is a scenic hill city near Pune. Popular for corporate outings and family weekend trips. The Pune to Lavasa highway route is ideal for SUV travel. Innova Crysta provides excellent long-distance comfort."
    },
    {
      title: "Lonavala",
      description:
        "Lonavala is a popular monsoon and weekend destination. Known for its greenery and hill views. Innova Crysta offers smooth expressway performance. Perfect for family and group travel."
    },
    {
      title: "Mahabaleshwar",
      description:
        "A beautiful hill station known for strawberries and viewpoints. Long-distance SUV travel is recommended. Innova Crysta ensures comfortable highway ride."
    },
    {
      title: "Khadakwasla Dam",
      description:
        "A popular picnic spot near Pune. Families visit during weekends. AC SUV travel makes journey relaxed and comfortable."
    }
  ],

  services: [
    {
      name: "Toyota Innova Crysta On Rent in Pune",
      description:
        "Premium Toyota Innova Crysta rental service in Pune for comfortable and luxury travel. Ideal for airport transfers, outstation trips, and family tours. AC vehicle with spacious interiors. Professional chauffeur included. Transparent pricing with flexible booking options."
    },
    {
      name: "Innova Crysta Taxi Pune",
      description:
        "Reliable Innova Crysta taxi service in Pune for local and long-distance travel. Clean and well-maintained SUV fleet available. Suitable for corporate and personal use."
    },
    {
      name: "Innova Crysta for Outstation Pune",
      description:
        "Comfortable outstation SUV travel from Pune to major cities. Ideal for long highway journeys. Professional drivers ensure safe travel."
    },
    {
      name: "Innova Crysta Airport Transfer Pune",
      description:
        "Timely airport pickup and drop service in Innova Crysta. Spacious seating and luggage support available."
    },
    {
      name: "Luxury Innova Crysta Pune",
      description:
        "Luxury SUV rental for weddings, corporate events, and VIP travel. Premium interiors and smooth highway ride."
    },
    {
      name: "7 Seater Innova Crysta Pune",
      description:
        "Spacious 7-seater SUV suitable for family travel. Comfortable seating and AC comfort ensured."
    },
    {
      name: "Corporate Innova Crysta Pune",
      description:
        "Professional SUV service for business executives and corporate travel. Reliable punctual pickup."
    },
    {
      name: "Online Innova Crysta Booking Pune",
      description:
        "Easy online booking for Innova Crysta rental with instant confirmation and 24/7 support."
    }
  ],

  tableData: [
    ["Innova Crysta On Rent in Pune", "Toyota Innova Crysta On Rent in Pune"],
    ["Innova Crysta Taxi Pune", "Innova Crysta for Outstation Pune"],
    ["Innova Crysta Airport Transfer Pune", "Luxury Innova Crysta Pune"],
    ["Innova Crysta Per Km Rate Pune", "Innova Crysta for Wedding Pune"],
    ["Corporate Innova Crysta Pune", "7 Seater Innova Crysta Pune"],
    ["AC Innova Crysta Taxi Pune", "Chauffeur Driven Innova Crysta Pune"],
    ["Family Trip Innova Crysta Pune", "Premium SUV Rental Pune"],
    ["Innova Crysta Drop Service Pune", "Online Innova Crysta Booking Pune"],
    ["Best Innova Crysta Hire Pune", ""]
  ],

  whychoose: [
    { WhyChooseheading: "Premium SUV Comfort", WhyChoosedescription: "Luxury seating and smooth suspension for long-distance travel." },
    { WhyChooseheading: "Professional Chauffeurs", WhyChoosedescription: "Experienced drivers trained for city and highway routes." },
    { WhyChooseheading: "Transparent Per Km Pricing", WhyChoosedescription: "Clear fare structure without hidden charges." },
    { WhyChooseheading: "Airport Transfer Ready", WhyChoosedescription: "Timely pickup and drop for Pune airport." },
    { WhyChooseheading: "Corporate Travel Solution", WhyChoosedescription: "Ideal for executive and business travel." },
    { WhyChooseheading: "Family-Friendly SUV", WhyChoosedescription: "Spacious 7-seater ideal for family trips." },
    { WhyChooseheading: "24/7 Booking Support", WhyChoosedescription: "Round-the-clock booking assistance." },
    { WhyChooseheading: "Safe Long-Distance Travel", WhyChoosedescription: "Reliable highway performance and secure travel." }
  ]
};

const faqData = [
  { question: "Do you provide 7 seater Innova Crysta?", answer: "Yes, 7-seater AC Innova Crysta available in Pune." },
  { question: "Is driver included?", answer: "Yes, professional chauffeur included." },
  { question: "Is outstation travel available?", answer: "Yes, outstation SUV rental available." },
  { question: "Is airport transfer available?", answer: "Yes, airport pickup and drop service provided." },
  { question: "Is online booking available?", answer: "Yes, instant booking available." },
  { question: "Are vehicles sanitized?", answer: "Yes, regularly cleaned and sanitized vehicles." },
  { question: "Is per km rate available?", answer: "Yes, transparent per km pricing provided." },
  { question: "Is corporate travel supported?", answer: "Yes, corporate bookings accepted." },
  { question: "Is round trip option available?", answer: "Yes, round-trip packages available." },
  { question: "Is luxury option available?", answer: "Yes, premium SUV options available." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "Booked Innova Crysta for outstation trip. Very smooth ride and comfortable seating. Professional driver and transparent pricing.",
    rating: 5
  },
  {
    id: 2,
    name: "Corporate Executive",
    feedback:
      "Used Innova Crysta for airport transfer. Timely pickup and excellent vehicle condition. Highly professional service.",
    rating: 5
  },
  {
    id: 3,
    name: "Family Client",
    feedback:
      "Comfortable SUV for our family tour. Spacious seating and safe driving. Great experience with Lotus Cab.",
    rating: 5
  }
];







































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Pune",
  "image": "https://lotuscab.com/assets/images/innova-crysta-on-rent-pune.jpg", 
  "description": "Lotus Cab offers Toyota Innova Crysta on rent in Pune for airport transfers, outstation trips, weddings, corporate travel, and family trips. Luxury 7-seater AC SUVs with professional chauffeur service, affordable per km rates, and online booking for comfortable, safe, and premium travel experiences.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "6300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1799",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/innova-crysta-on-rent-pune"
  }
};




  return (
    <div>
      


<Helmet>
  <title>Contact: +91 8767592195 | Innova Crysta On Rent in Pune | Lotus Cab</title>
  <meta 
    name="description" 
    content="Rent Toyota Innova Crysta in Pune with Lotus Cab. 7-seater luxury AC SUV for airport transfer, outstation, corporate, weddings & family trips. Chauffeur included. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Toyota Innova Crysta On Rent in Pune, Innova Crysta Taxi Pune, Innova Crysta for Outstation Pune, Innova Crysta Airport Transfer Pune, Luxury Innova Crysta Pune, Innova Crysta Per Km Rate Pune, Innova Crysta for Wedding Pune, Corporate Innova Crysta Pune, 7 Seater Innova Crysta Pune, AC Innova Crysta Taxi Pune, Chauffeur Driven Innova Crysta Pune, Family Trip Innova Crysta Pune, Premium SUV Rental Pune, Innova Crysta Drop Service Pune, Online Innova Crysta Booking Pune, Best Innova Crysta Hire Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/37.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinpune;